import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { CreMetric } from '../../../../../models/RiskProducts';
import { formatCommonDate } from '../../../../../utils/dateUtils';
import styles from './CreChartTooltipContent.module.scss';

const cx = classNames.bind(styles);

interface CreChartTooltipContentProps {
  creMetric: CreMetric;
}

const CreChartTooltipContent = ({ creMetric }: CreChartTooltipContentProps): ReactElement => {
  return (
    <div className={cx('body')} data-testid="cre-tooltip-content">
      {formatCommonDate(creMetric.calculationDate)}
      <span className={cx('value')}>{creMetric.crePercentage}%</span>
    </div>
  );
};

export default CreChartTooltipContent;
